export type MallCourse = 'MALL'

export type EasyBookingCourse = 'EASY_BOOKING'

export type SellerCourse = 'SELLER'

/** 주문형 주문서 타입 */
export type CheckoutCourse = MallCourse | EasyBookingCourse | SellerCourse

/** 주문형 주문서 타입 */
export type FamilyCourse = 'FAMILY'

export const Course = {
    MALL: 'MALL',
    EASY_BOOKING: 'EASY_BOOKING',
    SELLER: 'SELLER',
    FAMILY: 'FAMILY',
} as const

export type CourseType = MallCourse | EasyBookingCourse | SellerCourse | FamilyCourse
